import React, { useState } from 'react';
import { Box, Button, Stack, TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';
import { CancelButton, SubmitButton } from '../../../components/mui/Buttons/Buttons';
import { saveTarget } from '../../../redux/features/targetManagementSlice';

// Generalized "set target/slot for one person" dialog - the company-wide equivalent of
// views/ogd/myworkspace/TargetOrSlots/AddOrUpdateTarget.jsx (left untouched, still used by the
// OGD SOGO dashboard). This one works for whoever the backend says the current user may set a
// target for (Finance: anyone; everyone else: their own active reports).
export default function SetTargetDialog({ user, month, onSaved, disabled }) {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { saving } = useSelector((state) => state.targetManagement);
  const [open, setOpen] = useState(false);
  const [target, setTarget] = useState(user.target ?? '');
  const [slot, setSlot] = useState(user.slot ?? '');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (target === '' || slot === '' || Number.isNaN(Number(target)) || Number.isNaN(Number(slot))) {
      enqueueSnackbar('Target and Slot are both required numbers', { variant: 'error' });
      return;
    }
    dispatch(saveTarget({ assigned_to: user.userID, target: Number(target), slot: Number(slot), month })).then((res) => {
      if (res.payload?.status === 'error') {
        enqueueSnackbar(res.payload.message, { variant: 'error' });
        return;
      }
      enqueueSnackbar('Target saved', { variant: 'success' });
      setOpen(false);
      onSaved?.();
    });
  };

  return (
    <GlobalDialog
      maxWidth="xs"
      fullWidth
      title={`Target — ${user.name}`}
      open={open}
      setOpen={setOpen}
      closeButton
      closeCondition={() => setOpen(false)}
      popupButton={
        <Button variant="outlined" size="small" disabled={disabled} onClick={() => setOpen(true)}>
          Set Target
        </Button>
      }
      content={
        <form onSubmit={handleSubmit}>
          <Stack gap={1.5}>
            <TextField
              type="number"
              autoComplete="off"
              fullWidth
              label="Target"
              value={target}
              onChange={(e) => setTarget(e.target.value)}
              disabled={saving}
            />
            <TextField
              type="number"
              autoComplete="off"
              fullWidth
              label="Slot"
              value={slot}
              onChange={(e) => setSlot(e.target.value)}
              disabled={saving}
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Stack direction="row" spacing={1}>
                <CancelButton action={() => setOpen(false)}>Cancel</CancelButton>
                <SubmitButton disabled={saving} type="submit">
                  {saving ? 'Saving...' : 'Save'}
                </SubmitButton>
              </Stack>
            </Box>
          </Stack>
        </form>
      }
    />
  );
}
